import { useaxios } from "../../../utils/useaxios";
export default (customer_id) => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/customer_loan/customer_loan.php', { customer_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setcustomer_loan_report', payload: res.data });
            settable_type("customer_loan_report");
        }
        // setloading(false);
    });
}